
/**
 * @fileOverview scrollIntoView module definition
 * @author Pat Shanahan
 * @modified 03/09/17
 */

(function (context) {
	'use strict';

	var require = context.require,
		requirejs = context.requirejs,
		define = context.define;

	define('utility/scrollIntoView',['require','jquery','lib/Util','GlobalEventDispatcher'],function (require) {
		var $ = require('jquery'),
			util = require('lib/Util'),
			GlobalEventDispatcher = require('GlobalEventDispatcher');

		$debug('**** scrollIntoView Set Up Started, use debug=scrollView for debug output **** ');
		$debug('**** scrollIntoView Set Up Started **** ', 'scrollView'); //syntax: $debug(message, urlParam);

		var scrollIntoView = function(){
			$debug('  Initializing scrollIntoView...', 'scrollView');
            /**
             * An object to hold all the enabled scroll listeners
             *
             * @default {}
             * @property scrollListeners
             * @type Object
             * @public
             */			
			this.scrollListeners = {};		
			
            /**
             * Event Dispatcher utility object
             *
             * @default null
             * @property eventDispatcher
             * @type Object
             * @public
             */			
			this.eventDispatcher = GlobalEventDispatcher.getEventDispatcher();			
			
			this.init();
		};
		
		scrollIntoView.prototype.init = function(){
            this.setOptions()
				.setupHandlers()
                .build();

            return this;
		};
		
		scrollIntoView.prototype.setOptions = function(){
			// No options to set for now
			
			return this;
		};
		
		scrollIntoView.prototype.setupHandlers = function(){
			var self = this;
			
			$debug('    Setting up handlers for scrollIntoView...', 'scrollView');
			
			$(window).on('scroll', function(){
				self.checkEventListeners();
			});
			
			return this;
		};
		
		scrollIntoView.prototype.build = function(){
			// Check to see if the DPL is already on screen before scrolling
			this.checkEventListeners();
			
			return this;
		};
		
		scrollIntoView.prototype.addScrollListener = function($el, eventName, screenbuffer, executeOnce){
			$debug('   Adding new scroll listener for: ' + eventName, 'scrollView');
			$debug('    screenbuffer: ' + screenbuffer, 'scrollView');
			$debug('    executeOnce: ' + executeOnce, 'scrollView');
			
			if(screenbuffer === undefined){
				screenbuffer = 0;
			};
			
			if(executeOnce === undefined){
				executeOnce = true;
			};
			
			this.scrollListeners[eventName] = {
				element: $($el),
				executeOnce: executeOnce,
				screenbuffer: screenbuffer
			};
					
			$debug('   New scrollListeners object:', 'scrollView');
			$debug(this.scrollListeners, 'scrollView');
		};
		
		scrollIntoView.prototype.checkEventListeners = function(){
			var self = this;
			
			$debug(this.scrollListeners, 'scrollView');
			
			$.each(self.scrollListeners, function(key, value){
				$debug('    Checking for scroll into view event ' + key, 'scrollView');
				
				self.isInView(self.scrollListeners[key], key, self);
			});
		};
		
		scrollIntoView.prototype.isInView = function(scrollListener, scrollListenerName, self){
			var docViewBottom = $(window).scrollTop()+$(window).height()*(1+scrollListener.screenbuffer),
				//docViewBottom = docViewTop + $(window).height(),
				$el = scrollListener.element,
				elemTop = $el.offset().top;
				//elemBottom = elemTop + $el.height();

			if(docViewBottom >= elemTop){
				$debug('   Scroll element for ' + scrollListenerName + ' is in view, firing event...', 'scrollView');
				
				self.fire(scrollListener, scrollListenerName, self);
			};
		};
		
		scrollIntoView.prototype.fire = function(scrollListener, scrollListenerName, self){
			self.eventDispatcher.publish(scrollListenerName);
			
			if(scrollListener.executeOnce){
				$debug('   ' + scrollListenerName + 'only set to fire once, removing for scrollListeners object...', 'scrollView');
				
				delete self.scrollListeners[scrollListenerName];
			}
		};
		
		return new scrollIntoView();

	});

}(MMMRequire));